import { Grid } from '@mui/material';
import TextInputField from 'Components/Forms/TextInputField';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';
import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import { ICompanyUser } from 'FeatureModules/Auth/types/companyUser.types';
import * as Yup from 'yup';

interface IUserEditFormProps {
  onSubmit: (values: Partial<ICompanyUser>) => void;
  user: ICompanyUser;
}

const companyUserSchema = Yup.object().shape({
  firstName: Yup.string().required('You must enter your first name'),
  lastName: Yup.string().required('You must enter your last name'),
  email: Yup.string().required('You must enter your email').email('Invalid email format'),
  telephoneNumber: Yup.string().optional(),
  jobTitle: Yup.string().optional(),
  department: Yup.string().optional(),
});

const UserEditForm: FC<IUserEditFormProps> = ({ onSubmit, user }) => {
  const { firstName, lastName, email, telephoneNumber, role, department } = user;

  return (
    <Formik
      initialValues={{
        firstName,
        lastName,
        email,
        telephoneNumber,
        role,
        department,
      }}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={companyUserSchema}
      onSubmit={values => onSubmit(values)}
    >
      {({ isSubmitting }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextInputField label="First name" name="firstName" placeholder="Max" />
            </Grid>
            <Grid item xs={6}>
              <TextInputField label="Last name" name="lastName" placeholder="Mustermann" />
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={6}>
                  <TextInputField
                    disabled
                    label="Email"
                    subtitle="We will send notifications and updates to this email. Contact our support to change it."
                    name="email"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <TextInputField
                label="Telephone"
                name="telephoneNumber"
                placeholder="+49 1234 56789"
              />
            </Grid>
            <Grid item xs={6}>
              <TextInputField
                label="Department"
                name="department"
                placeholder="e.g. Sustainability, Logistics, Finance"
              />
            </Grid>
            <Grid item xs={6}>
              <TextInputField
                label="Job title"
                name="jobTitle"
                placeholder="e.g. Sustainable Manager, Supply Chain Manager"
              />
            </Grid>
            <Grid container item spacing={2} justifyContent="flex-end" alignItems="center">
              <Grid item>
                <ThemeButton size="large" color="PRIMARY" loading={isSubmitting} type="submit">
                  Save
                </ThemeButton>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default UserEditForm;
